import { render } from "./AboutProductTable.vue?vue&type=template&id=0fff65f5&ts=true"
import script from "./AboutProductTable.vue?vue&type=script&lang=tsx"
export * from "./AboutProductTable.vue?vue&type=script&lang=tsx"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__